import { Link } from "react-router-dom";
import styled from "styled-components";
import { tokens, Page, Meta } from "../styles";

export const posts = [
  {
    title: "Navigating undergraduate research",
    desc: "Practical advice on finding, landing, and succeeding in research positions as an undergrad.",
    date: "January 2025",
    path: "/writing/research-advice",
  },
];

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
const Entry = styled.article`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const Title = styled(Link)`
  align-self: flex-start;
  font-family: ${tokens.serif};
  font-size: 19px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: -0.01em;
`;

export default function Writing() {
  return (
    <Page>
      <List>
        {posts.map((p) => (
          <Entry key={p.path}>
            <Title to={p.path}>{p.title}</Title>
            <p>{p.desc}</p>
            <Meta>{p.date}</Meta>
          </Entry>
        ))}
      </List>
    </Page>
  );
}